module.exports = __webpack_public_path__ + "img/home_tk_icon.1a359cb.png";